export const SITE_PICKER_ACTIVATION_DELAY = 300;

const MENU_AIM_TOLERANCE = 75;

export type MouseLocation = {
  x: number;
  y: number;
};

type MenuBounds = Pick<DOMRect, 'bottom' | 'left' | 'right' | 'top'>;

type ActivationDelayOptions = {
  hasActiveSite: boolean;
  lastDelayLocation: MouseLocation | null;
  menuBounds: MenuBounds | null;
  mouseLocations: MouseLocation[];
};

const getSlope = (location: MouseLocation, corner: MouseLocation) => (corner.y - location.y) / (corner.x - location.x);

const locationsMatch = (first: MouseLocation, second: MouseLocation) => first.x === second.x && first.y === second.y;

const isInsideMenu = (location: MouseLocation, bounds: MenuBounds) =>
  location.x >= bounds.left && location.x <= bounds.right && location.y >= bounds.top && location.y <= bounds.bottom;

export const getSitePickerActivationDelay = ({
  hasActiveSite,
  lastDelayLocation,
  menuBounds,
  mouseLocations,
}: ActivationDelayOptions) => {
  const currentLocation = mouseLocations[mouseLocations.length - 1];

  if (!hasActiveSite || !menuBounds || !currentLocation) {
    return 0;
  }

  const previousLocation = mouseLocations[0];

  if (!previousLocation || !isInsideMenu(previousLocation, menuBounds)) {
    return 0;
  }

  if (lastDelayLocation && locationsMatch(currentLocation, lastDelayLocation)) {
    return 0;
  }

  const upperRight = {
    x: menuBounds.right,
    y: menuBounds.top - MENU_AIM_TOLERANCE,
  };
  const lowerRight = {
    x: menuBounds.right,
    y: menuBounds.bottom + MENU_AIM_TOLERANCE,
  };
  const decreasingSlope = getSlope(currentLocation, upperRight);
  const increasingSlope = getSlope(currentLocation, lowerRight);
  const previousDecreasingSlope = getSlope(previousLocation, upperRight);
  const previousIncreasingSlope = getSlope(previousLocation, lowerRight);
  const isMovingTowardPreview = decreasingSlope < previousDecreasingSlope && increasingSlope > previousIncreasingSlope;

  return isMovingTowardPreview ? SITE_PICKER_ACTIVATION_DELAY : 0;
};
